import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../api/client";

/** Check permissions before mounting a restricted page or fetching its data. */
export default function RequireAccess({ area, children }: {
  area: "audit" | "admin";
  children: React.ReactNode;
}) {
  const { data: me, isPending, error, refetch } = useQuery({ queryKey: ["me"], queryFn: api.me });

  if (isPending) return <p role="status" className="text-sm text-slate-500">Checking access...</p>;
  if (error) return (
    <div className="card p-6 space-y-3">
      <p role="alert" className="text-sm text-liaise-red">We couldn't check your access. Please try again.</p>
      <button className="btn-secondary" onClick={() => refetch()}>Try again</button>
    </div>
  );

  const allowed = area === "admin" ? me?.is_admin === true : me?.sees_all === true;
  if (!allowed) return (
    <div className="card p-6 space-y-3">
      <h1 className="text-2xl font-bold text-liaise-navy">Access restricted</h1>
      <p className="text-sm text-slate-500">
        {area === "admin"
          ? "Admin is available to administrators only."
          : "Audit is available to administrators, authorised auditors and the recruitment team."}
      </p>
      <Link className="btn-secondary inline-flex" to="/">Back to assessments</Link>
    </div>
  );

  return <>{children}</>;
}
